import { render, staticRenderFns } from "./lookApply.vue?vue&type=template&id=1501baaa&scoped=true&"
import script from "./lookApply.vue?vue&type=script&lang=js&"
export * from "./lookApply.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1501baaa",
  null
  
)

export default component.exports